import React, { useEffect, useState } from 'react';
import './SentMailList.css';
import api from '../wrapper/API';
import Icon from '../home/Icon';

function SentMailList({ eventId, playerId, refreshTrigger }) {
  const [sentMails, setSentMails] = useState([]);

  useEffect(() => {
    if (!eventId || !playerId) return;
    api.get(`/Textblock/GetSentMails?eventId=${eventId}&playerId=${playerId}`)
      .then(response => setSentMails(response.data))
      .catch(() => {});
  }, [eventId, playerId, refreshTrigger]);

  return (
    <div className={'innerContainer'}>
      <div className={'sentMailSection'}>
        <label className={'innerContainerLabel'}>Gesendete E-Mails</label>
        {sentMails.length === 0 ? (
          <p className={'sentMailEmpty'}>Keine E-Mails gesendet</p>
        ) : (
          <ul className={'sentMailList'}>
            {sentMails.map(mail => (
              <li key={mail.id} className={'sentMailItem'}>
                <div className={'sentMailIcon'}>
                  <Icon icon={'mail'} />
                </div>
                <div className={'sentMailContent'}>
                  <span className={'sentMailSubject'}>{mail.subject ?? '(kein Betreff)'}</span>
                  <span className={'sentMailMeta'}>
                    {mail.textblockFrontendName ?? 'Benutzerdefiniert'} &middot; {formatDate(mail.sentAt)}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

function formatDate(iso) {
  const d = new Date(iso);
  const pad = n => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default SentMailList;
